import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { useTableData } from "./hooks/useTableData";

export const ProbesTable = () => {
	const classes = useTableStyles();
	const {
		state: { probes, eafProcessData },
	} = useHeatReportContext();

	const { columns } = useTableData();
	return (
		<Paper className={classes.borderAgGridTable} elevation={0}>
			<Box p={0}>
				<div
					style={{ height: "25rem" }}
					key={`${probes.length}-${eafProcessData.ProcessId}`}
				>
					<AgGridReact
						rowSelection="single"
						suppressRowClickSelection={true}
						pagination={false}
						singleClickEdit={false}
						tooltipShowDelay={0}
						tooltipHideDelay={2000}
						rowData={probes}
						columnDefs={columns}
						domLayout="normal"
						getRowId={(params) => params.data.ProbeId}
					/>
				</div>
			</Box>
		</Paper>
	);
};
